import {Component, EventEmitter, Input, Output} from '@angular/core';
import {FiltreItem} from "./filtre-item";

@Component({
  selector: 'vos-filtres',
  templateUrl: './vos-filtres.component.html',
})
export class VosFiltresComponent {

  @Input() filtres: Array<FiltreItem>;
  @Output() onRemove: EventEmitter<FiltreItem> = new EventEmitter<FiltreItem>();

  constructor() {
  }

  remove(filtre: FiltreItem): void {
    this.onRemove.emit(filtre);
  }

}



// WEBPACK FOOTER //
// /home/vsts/work/1/s/digicerba-modules/digicerba-formulaire-demat/digicerba-formulaire-demat-web/src/angular/cerba/src/app/common/components/vos-filtres/vos-filtres.component.ts